<template>
  <div class="my-1" v-if="hasData">
    <b-table
      hover
      striped
      responsive
      small
      primary-key="key"
      :items="hotspotsData"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: colWidth(field.key), minWidth: colMinWidth(field.key) }"
        >
      </template>
      <template #cell(name)="data">
        <div class="hotspot-name-cell">
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(countTs)="data">
        <HotspotBubbleChart
          :hotspotKey="data.item.key"
          :url="data.item.countTsUrl"
          :timeRange="timeRange"
          @hotspot-click="showRowDetail({ item: data.item }, $event)"
        ></HotspotBubbleChart>
      </template>
      <template #row-details="{ item }">
        <HotspotDetailsContent
          v-if="activeDetailKey === item.key"
          :hotspotKey="item.key"
          :timeRange="detailTimeRanges[item.key]"
        ></HotspotDetailsContent>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="paginationTotalRows"
      :per-page="perPage"
      align="right"
      first-number
      last-number
      prev-class="prev-item"
      next-class="next-item"
      class="my-1 mr-1 mb-1"
    />
  </div>
  <div v-else-if="loaded" class="p-1">{{ $t("No Data Available") }}</div>
  <SpinnerCmpt v-else class="my-4"></SpinnerCmpt>
</template>

<script>
import HotspotBubbleChart from '@/xvisor/components/launchPad/HotspotBubbleChart.vue';
import HotspotDetailsContent from '@/xvisor/components/launchPad/HotspotDetailsContent.vue';
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';

export default {
  components: {
    HotspotBubbleChart,
    HotspotDetailsContent,
    SpinnerCmpt,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      currentPage: 1,
      perPage: 5,
      hotspots: [],
      detailTimeRanges: {},
      activeDetailKey: null,
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'countTs', label: '' },
      ],
    };
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    timeRange() {
      this.activeDetailKey = null;
      this.detailTimeRanges = {};
      this.httpGet();
    },
  },
  computed: {
    hasData() {
      return this.loaded && this.hotspotsData && this.hotspotsData.length > 0;
    },
    paginationTotalRows() {
      return this.hotspotsData.length;
    },
    hotspotsData() {
      return this.hotspots.map((hotspot) => ({
        ...hotspot,
        _showDetails: this.activeDetailKey === hotspot.key,
        countTsUrl: `/apps/hotspots/${hotspot.key}/countts.json`,
      }));
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.hotspots = response.data; })
        .finally(() => { this.loaded = true; });
    },
    showRowDetail({ item }, detailEvent) {
      const nextTimeRange = detailEvent && detailEvent.timeRange ? detailEvent.timeRange : this.timeRange;
      const currentTimeRange = this.detailTimeRanges[item.key];
      const isSameRow = this.activeDetailKey === item.key;
      const isSameTimeRange = currentTimeRange
        && currentTimeRange.start.getTime() === nextTimeRange.start.getTime()
        && currentTimeRange.end.getTime() === nextTimeRange.end.getTime();
      if (isSameRow && isSameTimeRange) {
        this.$delete(this.detailTimeRanges, item.key);
        this.activeDetailKey = null;
      } else {
        if (this.activeDetailKey !== null && this.activeDetailKey !== item.key) {
          this.$delete(this.detailTimeRanges, this.activeDetailKey);
        }
        this.$set(this.detailTimeRanges, item.key, nextTimeRange);
        this.activeDetailKey = item.key;
      }
    },
    colWidth(fieldKey) {
      switch (fieldKey) {
        case 'name': return '25%';
        case 'countTs': return '70%';
        default: return '180px';
      }
    },
    colMinWidth(fieldKey) {
      switch (fieldKey) {
        case 'name': return '100px';
        case 'countTs': return '300px';
        default: return '80px';
      }
    },
  },
};
</script>

<style scoped>
.hotspot-name-cell {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
